module.exports = __webpack_public_path__ + "img/sticker-0-6.6dd5c5e7.svg";